module.exports = __webpack_public_path__ + "img/introduction02_top_03.07028e6d.png";